module.exports = __webpack_public_path__ + "static/media/home1.f02dc1cc.png";